<template>
  <div class="c-profile__summary">
    <div class="c-quote">
      {{ translate(thingsToTranslate.quote) }}
    </div>
  </div>
</template>

<script>
import { translate } from "../../mixins";

export default {
  name: "ProfileSummary",
  mixins: [translate],
  data() {
    return {
      thingsToTranslate: {
        quote: {
          en: "I accept only thoughts that support me and make me feel good.",
          nl: "Ik accepteer alleen gedachten die mij helpen en waar ik me goed door voel."
        }
      }
    };
  },
  methods: {}
};
</script>

<style lang="scss">
.c-profile__summary {
  position: relative;
  display: flex;
  align-items: center;
  margin: -16px -16px 0 -16px;
  min-height: 40vh;
  padding: 60px 0;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    display: block;
    width: 100%;
    height: 38vh;
    background-image: linear-gradient(80deg, #b5e0f7, #5fa9d1);
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
    box-shadow: 0 3px 20px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    transform: scaleX(1.7);
  }
}

.c-quote {
  color: #fff;
  font-size: 1.8rem;
  font-weight: 800;
  text-align: right;
  line-height: 1;
  opacity: 0.6;
  padding: 0 24px;

  &::before {
    content: "\201C";
    position: absolute;
    left: 2rem;
    font-family: Times New Roman;
    font-size: 100px;
    font-weight: 800;
    color: #fff;
    opacity: 0.2;
  }
}
</style>
